import { Button } from 'components/Elements';
import React from 'react'
import { CiDesktop } from 'react-icons/ci';

export const DeviceRestriction = () => {
    return (
      <div className="flex flex-col items-center justify-center w-screen h-screen bg-gray-100 text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Admin Panel Access Restricted</h1>
        <p className="text-lg text-gray-600 mb-6">
          This admin panel is only accessible on laptops and desktops. Please switch to a compatible
          device to continue.
        </p>
        <CiDesktop className="w-1/2 max-w-md mb-6" />
        <Button
          onClick={() => window.location.reload()}
          className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow"
        >
          Retry
        </Button>
      </div>
    );
  };